import React, {
    FunctionComponent, useEffect, useRef
} from "react";
import styles from "./Masthead.module.scss";
import {fireSupGA} from "../../hooks/tagging";
import {scrollTo} from "../../libs/scroll";
import { isEs } from "../../libs/lang";

import content from "./content";

import classNames from "classnames";


const Masthead: FunctionComponent<{ contentIndex: number, isEvergreen: boolean, isStartSmart: boolean, focus: string }> = ({
    contentIndex, isEvergreen, isStartSmart, focus
}) => {

    const thisRef = useRef<HTMLParagraphElement>(null)
    const initialized = useRef(false)
    const getOffset = (target: any) => {
        return target!.getBoundingClientRect().top + (window.innerHeight / 2)
    }

    // this is duplicate code.  need to put in a lib.  can also find in Tile and Hero components. - DC
    useEffect(() => {
        if (!initialized.current) {
            if (thisRef.current) {
                initialized.current = true;
                const sups = thisRef.current.querySelectorAll('A')
                console.log(' *********** ', sups)
                sups.forEach((sup: any) => {
                    const keyUpHandler = (event: any) => {
                        if (event.which === 13) {
                            event.preventDefault();
                            event.stopPropagation();
                            fireSupGA({ clickText: sup.innerText });
                            const target = document.getElementById(`fn-${sup.innerText}`)
                            const offset: number = getOffset(target);
                            scrollTo(offset, () => setTimeout(() => {
                                target?.focus()
                            }, 500), true);
                        }
                    }

                    sup.addEventListener('keydown', (e: any) => keyUpHandler(e));

                    const clickHandler = (event: any) => {
                        console.log('here')
                        event.preventDefault();
                        event.stopPropagation();
                        fireSupGA({ clickText: sup.innerText });
                        const target = document.getElementById(`fn-${sup.innerText}`)
                        const offset: number = getOffset(target);

                        scrollTo(offset, () => setTimeout(() => {
                            target?.focus()
                        }, 500), true);
                    }

                    sup.addEventListener('click', (e: any) => clickHandler(e));

                    return () => {
                        document.removeEventListener('keydown', keyUpHandler);
                        document.removeEventListener('click', clickHandler);
                    };
                })
            }

        }
    })
    const getmastheadContent = () => {
        let contentArray: any;
        if (isEvergreen) {
            contentArray = process.env.REACT_APP_LANG === 'spanish' ? content.spanish.evergreen : content.english.evergreen;
        }
        else if (isStartSmart) {
            contentArray = process.env.REACT_APP_LANG === 'spanish' ? content.spanish.dynamic[5] : content.english.dynamic[5];
        }
        else if (contentIndex === 5) {
            contentArray = process.env.REACT_APP_LANG === 'spanish' ? content.spanish.dynamic[5] : content.english.dynamic[6];
        }
        else {
            contentArray = process.env.REACT_APP_LANG === 'spanish' ? content.spanish.dynamic[contentIndex] : content.english.dynamic[contentIndex];
        }
        return contentArray

    }
    const dataLang = process.env.REACT_APP_LANG === 'spanish' ? 'es' : 'en';

    const mastheadContent = () => getmastheadContent()

    console.log('contentIndex ', contentIndex)
    console.log(mastheadContent())


    return (
        <section id="masthead" data-lang={dataLang} data-tracking="section-masthead"

            className={classNames([styles.masthead, 'fullscreen'])} aria-label={mastheadContent().alt}>

            <div className={classNames([styles.content, styles[mastheadContent().class]])} data-lang={dataLang}>


                <h1 lang={dataLang} data-version={focus} ref={thisRef}>

                    {mastheadContent().headline}

                </h1>

                <div className={styles.gradient}></div>

            </div>
        </section>
    );
};

export default Masthead;
